module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TZP8FP7","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"chilli-ui","site":"gradireland"}},"gtmAuth":"hagXZX5dMgIi8v3a8IZbbw","gtmPreview":"env-1","routeChangeEventName":"gatsby-route-change-unused","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../plugins/gatsby-plugin-chilli-ui/gatsby-browser.js'),
      options: {"plugins":[],"api":"/ext/svc/abacus-capture/a3cdeb4f-336e-42bb-b197-970af0eee26b","defaultDataLayer":{"type":"object","value":{"platform":"chilli-ui","site":"gradireland"}},"abacusEnabled":true},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
